import React from 'react';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';

import NavigationRoutes from './routes';
import theme from './theme';
import { ToastContainer } from 'react-toastify';
import 'react-image-crop/dist/ReactCrop.css';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient();

const App = () => {
  return (
    <Box>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <NavigationRoutes />
          <ToastContainer />
        </ThemeProvider>
      </QueryClientProvider>
    </Box>
  );
};

export default App;
